




















































































import Vue from 'vue';
import { BForm, BFormGroup, BFormInput, BInputGroup, BFormRadio, VBTooltip } from 'bootstrap-vue';
import TextFieldWithCopyButton from '../../authentication/saml/components/TextFieldWithCopyButton.vue';
import { ticketingGetAuthInfo } from '@/utils/crudActions';

export default Vue.extend({
  name: 'ChooseAuthType',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BInputGroup,
    TextFieldWithCopyButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      authInfo: {},
      form: null,
    };
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  async created() {
    this.form = Object.assign({}, this.value);
    try {
      const data = await this.ticketingGetAuthInfo();
      this.authInfo = data;
    } catch (error) {
      /**
       * Necessary to ease debugging
       */
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
  methods: {
    emitNext() {
      this.$emit('onNextStep');
    },
    ticketingGetAuthInfo,
  },
});
